import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/internal/Subscription';

import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import { SwapScenarioDialogComponent } from '../swap-scenario-dialog/swap-scenario-dialog.component';
import { getScenarioId } from 'src/app/spatial-modeller-store/selectors';
import { ScenarioActionGuardService } from 'src/app/spatial-modeller/services/scenario-action-guard.service';

@Component({
  selector: 'atlas-swap-scenario',
  templateUrl: './swap-scenario.component.html',
  styleUrls: ['../less/scenario-management-button.component.less'],
  standalone: false
})
export class SwapScenarioComponent implements OnInit, OnDestroy {
  private currentScenarioId: number;
  private subscription = new Subscription();

  @Input() disabled: boolean | null = false;
  @Output() swapScenarioClicked = new EventEmitter();

  constructor(
    public dialogService: DialogService,
    private scenarioGuard: ScenarioActionGuardService,
    private store$: Store
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store$.select(getScenarioId).subscribe((id) => {
        this.currentScenarioId = id;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSwapScenario() {
    this.scenarioGuard.handleAction(
      () => this.openSwapScenarioDialog(),
      $localize`:@@changeScenario:Change scenario`
    );
  }

  private openSwapScenarioDialog(): void {
    this.dialogService.show(SwapScenarioDialogComponent, {
      width: DialogWidth.Small,
      panelClass: 'dialog-full-width-height',
      data: {
        headerText: $localize`:@@switchScenarioHeader:Switch scenario`,
        currentScenarioId: this.currentScenarioId,
        showCloseButton: true
      },
      disableClose: true
    });
  }
}
